exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media screen and (max-width:900px){.people2[data-v-77c9ac73]{background:#fff;border-radius:2px;padding:15px 10px}}@media screen and (min-width:900px){.people2[data-v-77c9ac73]{background:#fff;border-radius:2px;padding:15px 15px 50px}}.c-t[data-v-77c9ac73]{margin:30px 0 15px}.fade-enter-active[data-v-77c9ac73],.fade-leave-active[data-v-77c9ac73]{transition:all .4s ease}.fade-enter[data-v-77c9ac73],.fade-leave-active[data-v-77c9ac73]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77c9ac73","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/people2.vue
// module id = 175
// module chunks = 1